import InfoHeader from "../infoHeader/InfoHeader";
import {AddonGroupDataType} from "../../interfaces/addonGroup/AddonGroup.type";
import ListingAddonCard from "../listingAddonCard/ListingAddonCard";
import {ListingAddonCardDataType} from "../../interfaces/listingAddonCard/ListingAddonCard.type";
import HeaderGroup from "../headerGroup/HeaderGroup";
import {styleHelper} from "../../helpers/commonFunctions";
import styles from "./AddonGroup.module.css";
const AddonGroup = ({ items }: { items: AddonGroupDataType[] }) => {
    const item = items[0];
    const infoHeader = [item.infoHeader];
    const addonCards = item.addons;
    const header = [item.header];
    const dashedSeparator = item.dashedSeparator;
    return (
        <div
            className={`vas-card vas-flex-column vas-gap-3 ${styles.white_border} vas-border-radius vas-align-item vas-d-flex vas-pb-3 vas-w-100`}>
            <div className={`vas-d-flex vas-px-3 vas-pt-3`}>
                <HeaderGroup items={header}/>
            </div>
            <div
                className={`vas-dotted-line vas-p-0 vas-m-0`}
                style={styleHelper({borderColor: dashedSeparator?.color})}
            />
            <div className={`vas-d-flex vas-px-3`}>
                <InfoHeader items={infoHeader}/>
            </div>
            {
                addonCards?.map((item: ListingAddonCardDataType, idx: number) => {
                    return <div className={`vas-px-3`}><ListingAddonCard item={item} key={idx}/></div>;
                })
            }
        </div>
    )

};

export default AddonGroup;